/**
 * Loyalty balances and point totals are whole numbers; fractional API values use Math.floor (matches SQL FLOOR).
 */
export function floorLoyaltyPoints(value) {
  if (value == null || value === "") return 0;
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.floor(n);
}
